import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoutes = ({ children }) => {
  const token = localStorage.getItem('token');
  const employer = JSON.parse(localStorage.getItem('employer'));

  if (!token || !employer || !employer.statut_compte) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoutes;
